import styled from 'styled-components'

export const GlobalSearchListItemContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space.xsmall};
  min-width: 0;
`
